import {useCallback} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';

import {onKlarnaError} from 'libs/klarna/klarna';

import {OnAuthorizeCallbackType} from '../klarnaProvider';

/**
 * Return klarna authorize method
 *
 * @param {string} paymentMethod
 * @param {string} sessionId
 * @param {OnAuthorizeCallbackType} onAuthorizeCallback
 * @return function
 */
export const useKlarnaAuthorize = (
    paymentMethod: string,
    sessionId: string,
    onAuthorizeCallback: OnAuthorizeCallbackType,
) =>
    useCallback(() => {
        if (window.Klarna) {
            window.Klarna.Payments.authorize(
                {payment_method_category: paymentMethod},
                ({approved, authorization_token: token, error, show_form: widgetReadyToWork}) => {
                    if (approved) {
                        onAuthorizeCallback({
                            method: PAYMENTS.METHOD_KLARNA,
                            paymentId: sessionId,
                            token,
                        });
                    }

                    if (error)
                        sendDesktopAnalyticsEvent(
                            CHECKOUT_PAYMENT_STEP,
                            {
                                message: `Error - Authorization error - Please enter a valid field - ${error.invalid_fields}`,
                                method: PAYMENTS.METHOD_KLARNA,
                            },
                            false,
                        );

                    if (!widgetReadyToWork)
                        sendDesktopAnalyticsEvent(
                            CHECKOUT_PAYMENT_STEP,
                            {
                                message:
                                    'Error - Authorization error - There was an error with your payment with Klarna, please choose another payment method',
                                method: PAYMENTS.METHOD_KLARNA,
                            },
                            false,
                        );
                },
            );
        } else {
            onKlarnaError();
        }
    }, [paymentMethod, sessionId, onAuthorizeCallback]);
